<li class="btn-wave" data-ui-sref-active="active"><a data-ui-sref="pages.profile.profile-about">About</a></li>
<li class="btn-wave" data-ui-sref-active="active"><a data-ui-sref="pages.profile.profile-timeline">Timeline</a></li>
<li class="btn-wave" data-ui-sref-active="active"><a data-ui-sref="pages.profile.profile-photos">Photos</a></li>
<li class="btn-wave" data-ui-sref-active="active"><a data-ui-sref="pages.profile.profile-connections">Connections</a></li>
